<template>
    <group-category-tags :groups="groups" variant="wrap" :max-visible-tags="maxVisibleTags" />
</template>

<script>
import GroupCategoryTags from '@/components/groups/GroupCategoryTags.vue';

export default {
    name: 'MetaGroups',

    components: {
        GroupCategoryTags,
    },

    props: {
        groups: {
            type: Array,
            required: true,
        },

        maxVisibleTags: {
            type: Number,
            required: false,
            default: null,
        },
    },
};
</script>
